import {AfterViewInit, Component} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {BreakpointService} from '@app/services/breakpoint.service';
import {UserInfo} from '@app/model/user-info.model';
import {UserInfoService} from '@app/services/user-info.service';
import {RouterScrollService} from '@app/services/router-scroll.service';

@Component({
	selector: 'app-content-layout',
	templateUrl: './content-layout.component.html',
	styleUrls: ['./content-layout.component.scss']
})
export class ContentLayoutComponent implements AfterViewInit {
	isExpanded$ = new BehaviorSubject<boolean>(false);
	userInfo$: Observable<UserInfo>;
	mobile$: Observable<boolean>;

	constructor(breakpointService: BreakpointService, userInfoService: UserInfoService, private routerScrollService: RouterScrollService) {
		this.mobile$ = breakpointService.mobile$;
		this.userInfo$ = userInfoService.getUserInfo$();
	}

	toggleSidenav(): void {
		this.isExpanded$.next(!this.isExpanded$.value);
	}

	ngAfterViewInit(): void {
		this.routerScrollService.enableScrollPositionRestoration();
	}
}
